import { FormatStringByWordLength, DoArraysOverlap, Split, Join } from "../../../shared/scripts/array-functions";

export interface CTMSAddressEntity {
    Id: number;
    AddressTypeId: number;
    Address: string;
}

export interface CTMSUserEntity {
    Id: number;
    PortalId: number;
    Name: string;
    Email: string;
    PhoneNumber: string;
    RoleId: number;
    IsArchived: boolean;
}

export interface CTMSUserSiteEntity {
    Id: number;
    CTMSUserId: number;
    CTMSUser: CTMSUserEntity;
    CTMSSiteId: number;
    RoleId: number;
}

export interface CTMSStudyEntity {
    Id: number;
    Name: string;
}

export interface CTMSSiteStudyEntity {
    Id: number;
    CTMSSiteId: number;
    CTMSStudyId: number;
    CTMSStudy: CTMSStudyEntity;
    CurrentStatusId: number;
    CurrentStatusDate: string;
    IsArchived: boolean;
}


export interface SiteStudyStatusDto {
    StudyName: string;
    Status: string;
}


export class SiteLevelSummaryDto {
    Id: number;
    SiteNumber: number;
    SiteName: string;
    CTMSStudy: CTMSStudyEntity[];
    StudyList: string[];
    UserNames: string[];
    StudyStatuses: string[];
    SiteStudyStatuses: SiteStudyStatusDto[];

    constructor() { }

    initialize(): void {
        this.StudyList = this.CTMSStudy?.map(study => study.Name) ?? [];
    }

    matchesFilter(study: string[], siteManagers: string[], studyStatuses: string[]): boolean {


        if (!study?.length || !siteManagers?.length || !studyStatuses?.length ) { return false; }


        const managerValues = this.UserNames?.length > 0 ? this.UserNames : ["Unassigned"];

        if (!DoArraysOverlap(siteManagers, managerValues)) { return false; }

        const hasNoStudyAssignments = !this.SiteStudyStatuses?.length;

        if (hasNoStudyAssignments) { return study.includes("Unassigned") && studyStatuses.includes("Unassigned"); }

        return this.SiteStudyStatuses.some(pair => study.includes(pair.StudyName) && studyStatuses.includes(pair.Status) );

    }
}
export class SiteEntity {
    Id: number;
    SiteNumber: number;
    SiteName: string;
    SubcontractNumber: string;
    PONumber: string;
    VendorNumber: string;
    ChargeCode: string;
    Address: CTMSAddressEntity;
    ContractName: string;
    RedCapId: number;
    ShowOnPortal: boolean;
    IsArchived: boolean;
    CTMSUserSites: CTMSUserSiteEntity[];
    CTMSSiteStudies: CTMSSiteStudyEntity[];

    CTMSStudy: CTMSStudyEntity[];
    CTMSStudies: CTMSStudyEntity[];
    StudyList: string[];
    UserNames: string[];
    //get CTMSStudies(): CTMSStudyEntity[] {
    //    return this.CTMSSiteStudies?.map(ss => ss.CTMSStudy) ?? [];
    //}

    constructor() { }

    initialize(): void {
        this.StudyList = this.CTMSStudy?.map(study => study.Name) ?? [];
    }

    matchesFilter(study: any, siteManagers: any): boolean {

        if (!DoArraysOverlap(study, this.StudyList)) { return false; }
        //if (!DoArraysOverlap(siteManagers, this.UserNames)) { return false; }
        let values: string[] = [];
        if (this.UserNames.length > 0) { values.push(...this.UserNames); }
        else { values.push("Unassigned"); }
        if (!DoArraysOverlap(siteManagers, values)) { return false; }

        return true;
    }
}